import { FileDto } from '../../../shared/modules/files/dtos/file.dto';

/**
 * Create vehicle insurance claim DTO
 */
export class CreateVehicleInsuranceClaimDto {
	notes?: string;
	files?: FileDto[];
}
